import {
  CRM_EMAIL_SCOPE,
  MEMBER_EMAIL_SCOPE,
  PROJECT_EMAIL_SCOPE,
  type PlaceholderScope,
  QUOTE_EMAIL_SCOPE,
  REQUIREMENT_EMAIL_SCOPE,
} from "@msys/textutils";
import { Modal } from "@msys/ui";
import { Box, Typography } from "@mui/material";
import { useTranslate } from "@tolgee/react";
import { EmailTemplateContext } from "../../../../clients/graphqlTypes.js";
import { GroupedPlaceholdersList } from "../../documents/GroupedPlaceholdersList.js";

interface Props {
  context?: EmailTemplateContext;
  handleClose(): void;
}

function scopeFor(context: EmailTemplateContext | undefined): PlaceholderScope {
  switch (context) {
    case "PROJECT":
      return PROJECT_EMAIL_SCOPE;
    case "REQUIREMENT":
      return REQUIREMENT_EMAIL_SCOPE;
    case "QUOTE":
      return QUOTE_EMAIL_SCOPE;
    case "MEMBER":
      return MEMBER_EMAIL_SCOPE;
    case "CRM":
    default:
      return CRM_EMAIL_SCOPE;
  }
}

export function OrganisationEmailTemplateAvailableReplacementsModal({
  context,
  handleClose,
}: Props) {
  const { t } = useTranslate(["OrganisationSettings", "Global"]);

  return (
    <Modal
      title={t("Using placeholders in texts", {
        ns: "OrganisationSettings",
      })}
      handleClose={handleClose}
      notInStack
      actionButtons={[
        {
          label: t("Close", {
            ns: "Global",
          }),
          handleClick: handleClose,
        },
      ]}
      maxWidth="md"
    >
      <Typography variant="body1" gutterBottom>
        {t(
          "You can use placeholders to fill in information automatically in your emails.",
          {
            ns: "OrganisationSettings",
          }
        )}
      </Typography>
      <Typography variant="body1">
        {t(
          "The following placeholders are available for use in the subject and text of the emails.",
          {
            ns: "OrganisationSettings",
          }
        )}
      </Typography>
      <Box
        sx={{
          pt: 2,
        }}
      >
        <Typography variant="h4" gutterBottom>
          {t("For Emails:", {
            ns: "OrganisationSettings",
          })}
        </Typography>
        <GroupedPlaceholdersList scope={scopeFor(context)} />
      </Box>
    </Modal>
  );
}
